import { initializeApp } from 'firebase/app';
import { getAuth, setPersistence, browserLocalPersistence } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyDjFoOfnc77ohdl5LuooGC_jS7eFjTRG48",
  authDomain: "yard-2ae07.firebaseapp.com",
  projectId: "yard-2ae07",
  storageBucket: "yard-2ae07.firebasestorage.app",
  messagingSenderId: "831459353454",
  appId: "1:831459353454:web:c44b7e5f9ee9006fb2177f",
  measurementId: "G-P4CHTRWGY8"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

// Set persistence to local to keep user signed in
setPersistence(auth, browserLocalPersistence);

// Debug: Log auth state changes
auth.onAuthStateChanged((user) => {
  console.log('Auth state changed:', user);
});

export { auth }; 